import React, { Component } from 'react';
import { Modal, Tooltip } from 'antd';
import { FormattedMessage } from 'react-intl';
import BotConfigContainer from '../BotConfig/BotConfig';
import messages from '../ManualSearchV2/ManualSearchMessages';
import styles from './BotConfigDrawer.module.scss';
import { AryaBotIcon } from '../../Icons/AryaIcons';

export default class BotConfigDrawerContainer extends Component {
  getModalTitle = () => {
    const { jobTitle, jobId } = this.props;
    const AppName = 'Leo';
    return (
      <div className={styles.modalTitle}>
        <AryaBotIcon style={{ color: '#83878c', fontSize: '30px' }} />
        <div className={styles.modalTitleText}>
          <b>
            <FormattedMessage {...messages.botConfigurationLabel} values={{ AppName }} />
          </b>
          <div style={{ display: 'flex', gap: '3px' }}>
            <Tooltip title={jobTitle}>
              <div style={{ maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {jobTitle}
              </div>
            </Tooltip>
            <div>&nbsp;|&nbsp;{jobId}</div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const {
      visible,
      jobId,
      onClose,
      botDrawerRenderFlag,
      showBotQuestionsReviewMessage,
      updateReviewMessageVisibility,
    } = this.props;
    if (!botDrawerRenderFlag) return null;
    return (
      <Modal
        title={this.getModalTitle()}
        bodyStyle={{ maxHeight: '71vh', overflowY: 'scroll', paddingBottom: '35px' }}
        width={900}
        visible={visible}
        onCancel={onClose}
        destroyOnClose
        footer={null}
        style={{ top: '75px' }}
        className={styles.botConfigModal}
      >
        <BotConfigContainer
          onClose={onClose}
          jobId={jobId}
          showBotQuestionsReviewMessage={showBotQuestionsReviewMessage}
          updateReviewMessageVisibility={updateReviewMessageVisibility}
        />
      </Modal>
    );
  }
}
